// extracted by mini-css-extract-plugin
export default {"title":"triceps_title__7DcSh","info":"triceps_info__iwEVN","button":"triceps_button__PZKA+","heading":"triceps_heading__FYutH"};